import styled from "@emotion/styled";
import { Timeline as BaseTimeline } from "metabase/common/components/Timeline";

export const Header = styled.h3`
  margin-bottom: 1rem;
`;

export const Timeline = styled(BaseTimeline)`
  padding-bottom: 1em;
`;
